export const ENQUIRY_STATUSES = [
  "new_lead",
  "no_response",
  "follow_up",
  "contacted",
  "visit_booked",
  "visit_completed",
  "visit_no_show",
  "trial_booked",
  "trial_completed",
  "converted",
  "lost",
  "unqualified",
];

export const getNextActionForStatus = (status: string): string => {
  const map: Record<string, string> = {
    new_lead: "Contact Lead",
    no_response: "Follow Up",
    follow_up: "Follow Up",
    contacted: "Book Visit",
    visit_booked: "Log Visit Outcome",
    visit_completed: "Book Trial",
    visit_no_show: "Follow Up",
    trial_booked: "Mark Trial Completed",
    trial_completed: "Log Trial Outcome",
    converted: "",
    lost: "",
    unqualified: "",
  };
  return map[status?.toLowerCase()] || "";
};

export const getNextStatusForStatus = (status: string): string => {
  const map: Record<string, string> = {
    new_lead: "follow_up",
    no_response: "follow_up",
    follow_up: "visit_booked",
    contacted: "visit_booked",
    visit_booked: "visit_completed",
    visit_completed: "trial_booked",
    visit_no_show: "follow_up",
    trial_booked: "trial_completed",
    trial_completed: "converted",
    converted: "",
    lost: "",
    unqualified: "",
  };
  return map[status?.toLowerCase()] || "";
};
